import { render } from "./NcrmPrivacyStackedBar.vue?vue&type=template&id=18baa41f&scoped=true"
import script from "./NcrmPrivacyStackedBar.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyStackedBar.vue?vue&type=script&lang=js"

import "./NcrmPrivacyStackedBar.vue?vue&type=style&index=0&id=18baa41f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18baa41f"]])

export default __exports__